import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogConfig,
} from '@angular/material/dialog';
import { LocationsEdit } from '../../../location/components/edit/component';
import { LocationApiService } from '../../../location/services/location-api-service';
import { LocationDataSource } from '../../../location/services/location-data-source';
import { ILocation } from '../../interfaces/location';

@Component({
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class LocationPicker {
  public listingTitle: string;
  public Locations: ILocation[] = [];
  public selectedLocation: ILocation | null;
  public Organisation: any;
  public DataSource = new LocationDataSource(
    this.Api,
    'organisation-admin',
    'getUserOrgs',
    this.data.organisation
  );

  constructor(
    private DialogRef: MatDialogRef<LocationPicker>,
    private Dialog: MatDialog,
    protected Api: LocationApiService,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.Locations = this.data.locations;
    this.listingTitle = this.data.listingTitle;
  }

  public selectLocation(Location: ILocation) {
    this.selectedLocation =
      this.selectedLocation !== Location ? Location : null;
  }

  public addNewLocation() {
    const DialogConfig = new MatDialogConfig();

    DialogConfig.data = {
      locationId: null,
      Location: null,
      dataSource: this.DataSource,
    };
    this.Dialog.open(LocationsEdit, DialogConfig)
      .afterClosed()
      .subscribe((location) => {
        location &&
          this.DialogRef.close({ ...location, companyLocationId: location.id });
      });
  }

  public submit() {
    this.DialogRef.close(this.selectedLocation);
  }
}
